import React from 'react';
import {
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { buildBacDiffNarrative } from './bacDiffNarrative.js';

const listCodes = (rows = []) => rows.slice(0, 3).map((row) => (
  row.count > 1 ? `${row.code} x${row.count}` : row.code
)).join(', ');

const BacDiffNarrativePanel = ({
  evidenceRows = {},
  sourceTotals = {},
  varianceActions = [],
  evidencePending = false,
  evidencePendingReason = null,
}) => {
  if (evidencePending) {
    const isWaiting = evidencePendingReason === 'pending';
    return (
      <Paper
        variant="outlined"
        sx={{
          p: 1.5,
          borderRadius: 1.5,
          bgcolor: 'info.lighter',
          borderColor: 'info.light',
        }}
      >
        <Stack spacing={0.35}>
          <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
            {isWaiting ? 'BAC evidence not warmed yet' : 'Warming BAC evidence'}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {isWaiting
              ? 'Showing stored variance totals while this BAC waits for a billing snapshot.'
              : 'Showing stored variance totals while the BAC snapshot finishes loading. Product evidence is not missing.'}
          </Typography>
        </Stack>
      </Paper>
    );
  }

  const narrative = buildBacDiffNarrative({
    gmLineItems: evidenceRows.gmLineItems || [],
    cpqLineItems: evidenceRows.cpqLineItems || [],
    sourceTotals,
    varianceActions,
  });
  const hasWork = narrative.gmExtra.length
    || narrative.cpqExtra.length
    || narrative.priceMismatchCount
    || narrative.hasUnexplainedTotalDelta;
  const compactFacts = [
    narrative.gmExtra.length ? `GM-only ${listCodes(narrative.gmExtra)}` : '',
    narrative.cpqExtra.length ? `CPQ-only ${listCodes(narrative.cpqExtra)}` : '',
    narrative.priceMismatchCount ? `${narrative.priceMismatchCount} price mismatch${narrative.priceMismatchCount === 1 ? '' : 'es'}` : '',
  ].filter(Boolean).join(' · ');

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        borderRadius: 1.5,
        bgcolor: hasWork ? 'warning.lighter' : 'success.lighter',
        borderColor: hasWork ? 'warning.light' : 'success.light',
      }}
    >
      <Stack spacing={0.35}>
        <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
          {narrative.humanSummary}
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {narrative.deltaDirection}
          {compactFacts ? ` ${compactFacts}.` : ''}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default BacDiffNarrativePanel;
